import { colors, fonts, pxToCssFont, pxToRem } from '@vfit/shared/themes';
import styled from 'styled-components';

export const Container = styled.div<{ darkMode?: boolean }>`
  width: fit-content;
  padding: ${pxToRem(16)} ${pxToRem(24)};
  display: flex;
  align-items: center;

  border: ${pxToRem(1)} solid ${({ darkMode }) => (darkMode ? 'white' : 'black')};
  border-radius: ${pxToRem(10)};

  & span {
    margin-right: ${pxToRem(10)};
    font-family: ${fonts.regular};
    font-weight: 700;
    ${pxToCssFont(18, 24)}
    color: ${({ darkMode }) => (darkMode ? colors.$ffffff : colors.$262626)};

  }
  & svg {
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
    color: ${({ darkMode }) => (darkMode ? colors.$ffffff : colors.$262626)};

  }
  & path {
    stroke: ${({ darkMode }) => (darkMode ? colors.$ffffff : colors.$262626)} !important;
    stroke-width: ${pxToRem(1.5)} !important;

  }

  :hover{
    background-color: ${({ darkMode }) => (darkMode ? colors.$ffffff : colors.$262626)};
    & span {
      color: ${({ darkMode }) => (darkMode ?  colors.$262626 : colors.$ffffff )};
    }
    & svg {
      ${({ darkMode }) => (darkMode ?  colors.$262626 : colors.$ffffff )};
    }
    & path {
      stroke: ${({ darkMode }) => (darkMode ?  colors.$262626 : colors.$ffffff )} !important;
    }
  }
`;

export const AnchorLabel = styled.span<{ darkMode?: boolean }>`
  color: ${({ darkMode }) => (darkMode ? colors.$ffffff : colors.$262626)};

`;

